import { isInvalidClass } from "../bootstrap-form-renderer";

export function scrollToFirstError() {
    document.querySelector(`.${isInvalidClass}`)?.scrollIntoView({ behavior: "smooth" });
}
